/* eslint no-param-reassign: "off" */

import ElementUpdater from './elementUpdater'
import Selector from './selector'

const updateTextView = (styles) => {
  const { backgroundColor, bodyFontSize, titleFontSize } = styles

  const headerHeight = '80px'
  const headerWrapperSelector = '.presentation_slide.text_slide .header_wrapper'
  const textSlideBackgroundImageSelector =
    '.presentation_slide.text_slide .slide_background_image_wrapper'
  const slideWrapperSelector = '.presentation_slide.text_slide .slide_wrapper'
  const slideTitleSelector = '.presentation_slide.text_slide .slide_title'
  const slideDescriptionSelector =
    '.presentation_slide.text_slide .slide_description'
  const slideMetaData = '.presentation_slide.text_slide .metadata'

  const selectors = [
    new Selector({
      selection: headerWrapperSelector,
      required: true,
    }),
    new Selector({
      selection: slideWrapperSelector,
      required: true,
    }),
    new Selector({
      selection: slideTitleSelector,
      required: true,
    }),
    new Selector({
      selection: slideDescriptionSelector,
    }),
    new Selector({
      selection: slideMetaData,
    }),
    new Selector({
      selection: textSlideBackgroundImageSelector,
    }),
  ]

  const updateStyles = () => {
    document
      .querySelectorAll(textSlideBackgroundImageSelector)
      .forEach((element) => {
        element.style.top = headerHeight
      })

    document.querySelectorAll(headerWrapperSelector).forEach((element) => {
      element.style['z-index'] = 2
    })

    document.querySelectorAll(slideWrapperSelector).forEach((element) => {
      element.style['background-color'] = backgroundColor
    })

    document.querySelectorAll(slideTitleSelector).forEach((element) => {
      element.style['font-size'] = titleFontSize
    })

    document.querySelectorAll(slideDescriptionSelector).forEach((element) => {
      element.style.height = bodyFontSize
      element.style['font-size'] = bodyFontSize
      element.style.padding = '0px'
    })
    document.querySelectorAll(slideMetaData).forEach((element) => {
      element.style['margin-bottom'] = headerHeight
    })
  }

  const updater = new ElementUpdater(selectors, updateStyles)
  updater.update()
}

export default updateTextView
